// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "./controllers"
import "flyonui/flyonui.js";
import { HSOverlay, HSStaticMethods } from "flyonui/flyonui"
import { startNumberInputFormalization } from "./pure/number_input_normalization"
 
declare global {
  interface Window {
    Stimulus: Application,
     HSOverlay: HSOverlay,
     HSStaticMethods: typeof HSStaticMethods,
  }
}

document.addEventListener("turbo:load", () => {
  window.HSStaticMethods.autoInit()
})

startNumberInputFormalization()
